import { appErrorPaths, buildAppErrorUrl } from "@/lib/app-error-routes";
import { getStoredUserId, setStoredUserString } from "@/lib/auth-storage";
import { clearWhatsAppReconnectDismissed } from "@/lib/whatsapp-reconnect";

export const SESSION_EXPIRED_EVENT = "openfarming:session-expired";

function getCurrentLocationHref() {
  if (typeof window === "undefined") {
    return undefined;
  }

  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function handleSessionExpired() {
  if (typeof window === "undefined") {
    return;
  }

  clearWhatsAppReconnectDismissed(getStoredUserId());
  setStoredUserString(null);
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));

  if (window.location.pathname === appErrorPaths["session-expired"]) {
    return;
  }

  window.location.replace(
    buildAppErrorUrl("session-expired", getCurrentLocationHref()),
  );
}
